import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  ChangeDetectionStrategy,
  inject,
  DestroyRef,
  ChangeDetectorRef,
  OnInit
} from '@angular/core';
import { tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-base-modal',
  templateUrl: './base-modal.component.html',
  styleUrl: './base-modal.component.scss',
  host: {
    '[style.display]': '"flex"',
    '[style.flex-direction]': '"column"',
    '[style.overflow]': '"auto"',
    '[style.z-index]': '"1000000"'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BaseModalComponent implements OnInit {
  private _destroyRef = inject(DestroyRef);
  private _cdr = inject(ChangeDetectorRef);
  private themeService = inject(ThemeService);

  // isLight: boolean = true;
  @Input() showClose = true;
  @Input() title!: string;
  @Output() closeCross = new EventEmitter<void>();
  @HostBinding('class.light') isLight = true;
  @HostBinding('class.dark') isDark = false;

  constructor() {
    /* noop */
  }

  ngOnInit() {
    this.themeService.isLight$
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        tap((x) => {
          this.isDark = !x;
          this.isLight = x;
          this._cdr.markForCheck();
        })
      )
      .subscribe();
  }

  onModalClose() {
    this.closeCross.emit();
  }
}
